import { Component, computed, Input, input, InputSignal, OnInit, Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ShipmentAppEntityShipmentRead
} from '../../../../../openapi';
import { LabelComponent } from '../../../../../common/label/label.component';
import { CommonModule } from '@angular/common';
import { UploaderAttachmentsService } from '../../../../../services/uploader-attachments.service';

import { AccordionGroupComponent } from '../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../common/accordion-item/accordion-item.component';
import { Store } from '@ngrx/store';
import {
  ApplicationPayment
} from '../../../../../services/application.common.model';
import { selectPayment } from '../../../../../store/selectors/application.selectors';
import { JoinPipe } from '../../../../../pipes/join.pipe';
import { AttachmentNamePipe } from '../../../../../pipes/attachment.name.pipe';
import { RouterModule } from '@angular/router';
import { ToNumberPipe } from '../../../../../pipes/to-number.pipe';
import { EntityLabelPipe } from '../../../../../pipes/applicant-label.pipe';
import {
  ApplicantItemPreviewComponent
} from '../../common/applicant-data-section/components/applicant-item-preview/applicant-item-preview.component';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import {
  RoadOccupationStageTableComponent
} from '../../common/occupation-data-section/components/road-occupation-stage-table/road-occupation-stage-table.component';
import { OccupationLabelPipe } from '../../common/occupation-data-section/pipes/occupation-label.pipe';
import {
  OccupationPreviewComponent
} from '../../common/occupation-data-section/components/occupation-preview/occupation-preview.component';
import {
  RoadOccupationFormValue,
  occupationsToFormValue
} from '../../common/occupation-data-section/forms/road-occupation.form';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import {
  PaymentsDataPreviewComponent
} from '../../common/payments-data-section/components/payments-data-preview/payments-data-preview.component';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';

@Component({
  selector: 'app-carrying-out-works-preview',
  standalone: true,
  imports: [
    CommonModule,
    LabelComponent,
    RoadOccupationStageTableComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    EntityLabelPipe,
    ApplicantItemPreviewComponent,
    OccupationLabelPipe,
    OccupationPreviewComponent,
    JoinPipe,
    AttachmentNamePipe,
    RouterModule,
    ToNumberPipe,
    AgreementsDataPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    ApplicantPreviewComponent,
    DecisionDataPreviewComponent,
    PaymentsDataPreviewComponent,
    ContractorDataPreviewComponent
  ],
  providers: [
    UploaderAttachmentsService
  ],
  templateUrl: './carrying-out-works-preview.component.html'
})
export class CarryingOutWorksPreviewComponent {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public payment: Signal<ApplicationPayment | null> = this.store$.selectSignal(selectPayment);

  public roadOccupations: Signal<RoadOccupationFormValue[]> = computed(() => occupationsToFormValue(this.application()?.roadOccupations || []));

  constructor(
    private store$: Store
  ) {
  }
}
